@if (isLoading) {
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>

<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<div class="margin-above"></div>

<!-- Not yet replaced (list of XPACs) -->
<ng-container *ngIf="!replaced">
  <app-search-bar [title]="'Modules.XpacReplacementComponent.Filter' | translate"
    [placeholder]="'Modules.RemoteMaintenance.FilterInfo' | translate"
    (onSearchTextChanged)="onSearchTextChanged($event)">
  </app-search-bar>
  <div class="action-buttons">
    <!-- Refresh -->
    <ng-container>
      <button mat-flat-button class="button small-button" (click)="refreshData()">
        <mat-icon>autorenew</mat-icon>
        <p>{{ 'Modules.XpacReplacementComponent.Refresh' | translate }}</p>
      </button>
    </ng-container>
  </div>

  <h2 class="panel-title" *ngIf="devicesToRestore.length">{{('Modules.XpacReplacementComponent.Available' |
    translate)}}</h2>

  <div *ngIf="devicesToRestore.length">
    <div class="panel">
      <ng-container *ngFor="let xpac of devicesToRestore">
        <app-list-item (onClickCallback)="replace(xpac)" [showActionIcon]="true" [actionIcon]="getActionIcon()"
          [title]="getTitleString(xpac)" [info]="getXpacInfoStringIdAndInstallationDate(xpac)"
          [info2]="getXpacInfoStringAddressAndRetailer(xpac)" [showItemStatus]="false">
        </app-list-item>
      </ng-container>
    </div>
  </div>

  <div *ngIf="isLoadingRestoreDevices">
    <mat-spinner class="spinner" diameter="28"></mat-spinner>
  </div>

  <!-- No devices -->
  <div class="panel-no-data" *ngIf="!devicesToRestore.length && !isLoadingRestoreDevices">
    {{ (searchText.length > 0 ? 'Modules.XpacReplacementComponent.NoStoresFiltered' :
    'Modules.XpacReplacementComponent.NoStores') | translate: { filter: searchText } }}
  </div>
</ng-container>

<!-- Replaced -->
<div class="panel-no-data" *ngIf="replaced">
  {{ ( 'Modules.XpacReplacementComponent.Replaced') | translate }}
</div>
}